export enum BUCKET_TYPE_ENUM {
  TRANSACTION = 'TRANSACTION',
  NOTIFICATION = 'NOTIFICATION',
  DOCUMENT = 'DOCUMENT',
  STATEMENT = 'STATEMENT',
  LOGO = 'LOGO',
  AVATAR = 'AVATAR',
}
